export default __webpack_public_path__ + "static/media/pic13.402f2f79.jpg";